<div class="project-create-page">
<section class="wizard-shell">
    @if (projectStatus) {

  <header class="wizard-header" [hidden]="currentStep === 4">
    <div class="wizard-eyebrow">YENİ PROJE</div>
    <h1>Proje oluştur</h1>
    <p>Proje bilgilerinizi tamamlayın ve oluşturulan projenin özetini kontrol edin.</p>
  </header>

  <nav class="wizard-steps">
    @for (step of steps; track step.id) {
      <div class="wizard-step"
           [class.active]="currentStep === step.id"
           [class.completed]="currentStep > step.id">
        <span class="wizard-step-number">
          @if (currentStep > step.id) {
            <i class="bi bi-check-lg"></i>
          } @else {
            {{ step.id }}
          }
        </span>
        <span class="wizard-step-title">{{ step.title }}</span>
        @if (step.id < 4) {
          <i class="bi bi-chevron-right wizard-step-arrow"></i>
        }
      </div>
    }
  </nav>

  <!-- STEP 1 -->
  @if (currentStep === 1) {
    <div class="wizard-content">
      <section class="limit-card">
        <div class="section-heading">
          <div>
            <span class="section-kicker">KULLANIM HAKKI</span>
            <h2>Proje Oluşturma Limitiniz</h2>
            <p>Mevcut paketinizde kullanılabilir proje hakkınızı kontrol edin.</p>
          </div>
          <span class="plan-badge">{{ projectStatus.packetName }}</span>
        </div>

        <div class="limit-main">
          <div class="limit-circle" [style.background]="limitCircleStyle">
            <div class="limit-circle-inner">
              <strong>{{ projectStatus.currentProjectNumber }} / {{ projectStatus.maxProjectLimitsNumber }}</strong>
          
            </div>
          </div>

          <div class="limit-statistics">
            <div class="limit-stat-row"><span>Toplam Limit</span><strong>{{ projectStatus.maxProjectLimitsNumber }}</strong></div>
            <div class="limit-stat-row"><span>Oluşturulan Proje</span><strong>{{ projectStatus.currentProjectNumber }}</strong></div>
            <div class="limit-stat-row"><span>Kalan Hak</span><strong [class.danger-text]="remainingProjectLimit === 0">{{ remainingProjectLimit }}</strong></div>
          </div>
        </div>

        @if (remainingProjectLimit > 0) {
          <div class="info-panel">
            <span class="panel-icon"><i class="bi bi-info-lg"></i></span>
            <div>
              <strong>Yeni proje oluşturabilirsiniz.</strong>
              <p>Her proje kendi uygulama bağlantısı, yapılandırması ve kullanım istatistikleri ile ayrı yönetilir.</p>
            </div>
          </div>
        } @else {
          <div class="limit-warning">
            <span class="warning-icon"><i class="bi bi-exclamation-lg"></i></span>
            <div class="warning-content">
              <strong>Proje oluşturma limitiniz bitmiştir.</strong>
              <p>Lütfen paket yükseltin ya da proje satın alın.</p>
            </div>
            <button type="button" class="package-button" (click)="goToPackages()">
              Paketleri İncele <i class="bi bi-box-arrow-up-right"></i>
            </button>
          </div>
        }
      </section>

      <div class="limit-help">
        <i class="bi bi-shield-check"></i>
        <div>
          <strong>Limitler Hakkında</strong>
          <p>Proje limiti hesabınıza tanımlı kullanım profilinden alınır. Limit dolduğunda yeni proje adımları kilitlenir.</p>
        </div>
      </div>

      <footer class="wizard-footer wizard-footer-right">
        <button type="button" class="primary-button" [disabled]="remainingProjectLimit <= 0" (click)="nextStep()">
          İleri <i class="bi bi-arrow-right"></i>
        </button>
      </footer>
    </div>
  }

  <!-- STEP 2 -->
  @if (currentStep === 2) {
    <div class="project-information-step">
      <div class="project-information-layout">
        <main class="project-information-card">
          <div class="section-heading">
            <div>
              <span class="section-kicker">PROJE BİLGİLERİ</span>
              <h2>Yeni projenizi tanımlayın</h2>
              <p>Uygulama seçmeden önce proje adını ve temel bilgilerini girin.</p>
            </div>
            <span class="plan-badge">2 / 4</span>
          </div>

          <div class="project-form">
            <div class="form-group">
              <label>Proje Adı <em>*</em></label>
              <input type="text"
                     maxlength="100"
                     [value]="project.name"
                     (input)="setProjectName($event)"
                     placeholder="Örn. Müşteri Destek Asistanı">
              <small>{{ project.name.length }}/100</small>
            </div>

            <div class="form-group">
              <label>Proje Açıklaması</label>
              <textarea maxlength="500"
                        [value]="project.description"
                        (input)="setProjectDescription($event)"
                        placeholder="Projenizin amacını ve kullanım alanını kısaca açıklayın."></textarea>
              <small>{{ project.description.length }}/500</small>
            </div>

            <div class="project-appearance">
              <div class="appearance-block">
                <div class="appearance-heading">
                  <div>
                    <label>Proje İkonu</label>
                    <span>Opsiyonel</span>
                  </div>
                  <small>{{ project.icon ? 'İkon seçildi' : 'İkon yok' }}</small>
                </div>

                <div class="icon-options">
                  <button type="button"
                          class="appearance-none-button"
                          [class.active]="!project.icon"
                          (click)="selectProjectIcon('')">
                    <i class="bi bi-slash-circle"></i>
                    <span>İkon Yok</span>
                  </button>

                  @for (icon of projectIcons; track icon) {
                    <button type="button"
                            class="project-icon-option"
                            [class.active]="project.icon === icon"
                            [style.color]="project.icon === icon && project.color ? project.color : null"
                            (click)="selectProjectIcon(icon)"
                            [attr.aria-label]="icon">
                      <i [class]="icon"></i>
                    </button>
                  }
                </div>
              </div>

              <div class="appearance-block">
                <div class="appearance-heading">
                  <div>
                    <label>İkon Rengi</label>
                    <span>Opsiyonel</span>
                  </div>
                  <small>{{ project.color ? project.color : 'Renk yok' }}</small>
                </div>

                <div class="color-options">
                  <button type="button"
                          class="appearance-none-button color-none"
                          [class.active]="!project.color"
                          (click)="selectProjectColor('')">
                    <i class="bi bi-slash-circle"></i>
                    <span>Renk Yok</span>
                  </button>

                  @for (color of projectColors; track color) {
                    <button type="button"
                            class="project-color-option"
                            [class.active]="project.color === color"
                            [style.--project-color]="color"
                            (click)="selectProjectColor(color)"
                            [attr.aria-label]="color">
                      <span></span>
                      @if (project.color === color) {
                        <i class="bi bi-check-lg"></i>
                      }
                    </button>
                  }
                </div>
              </div>
            </div>

            <div class="project-form-note">
              <i class="bi bi-info-circle"></i>
              <div>
                <strong>Bu bilgiler proje profilinde kullanılacaktır.</strong>
                <span>Bir sonraki adımda bu projeye bağlanacak API / SaaS / PaaS / IaaS / Cloud uygulamasını seçeceksiniz.</span>
              </div>
            </div>
          </div>
        </main>

        <aside class="project-information-preview">
          <span class="section-kicker">PROJE ÖNİZLEME</span>
          <div class="project-preview-icon"
               [class.empty]="!project.icon"
               [style.color]="project.color || null">
            @if (project.icon) {
              <i [class]="project.icon"></i>
            } @else {
              <i class="bi bi-slash-circle"></i>
            }
          </div>
          <span class="preview-label">Proje Adı</span>
          <h3>{{ project.name || 'Yeni Proje' }}</h3>
          <p>{{ project.description || 'Proje açıklaması henüz girilmedi.' }}</p>
          <div class="preview-row"><span>Durum</span><strong>Taslak</strong></div>
          <div class="preview-row"><span>İkon</span><strong>{{ project.icon ? 'Seçildi' : 'İkon yok' }}</strong></div>
          <div class="preview-row"><span>İkon Rengi</span><strong>{{ project.color || 'Renk yok' }}</strong></div>
          <div class="preview-row"><span>Uygulama</span><strong>Henüz seçilmedi</strong></div>
        </aside>
      </div>

      <footer class="step-footer">
        <button type="button" class="secondary-button" (click)="previousStep()">
          <i class="bi bi-arrow-left"></i> Geri
        </button>
        <button type="button" class="primary-button" [disabled]="!canContinueFromProjectInfo" (click)="nextStep()">
          İleri <i class="bi bi-arrow-right"></i>
        </button>
      </footer>
    </div>
  }

  <!-- STEP 3 -->
  @if (currentStep === 3) {
    <fieldset class="application-step application-step-lock" [disabled]="creatingProject">
      @if (createProjectError) {
        <div class="project-create-error" role="alert" aria-live="assertive" tabindex="-1" id="project-create-error">
          <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
          <div><strong>Proje oluşturulamadı</strong><p>{{ createProjectError }}</p></div>
          <button type="button" aria-label="Hata mesajını kapat" (click)="createProjectError = ''"><i class="bi bi-x-lg"></i></button>
        </div>
      }


      <div class="selected-project-bar mb-3">
        <div>
          <span>PROJE ADI</span>
          <strong>{{ project.name }}</strong>
        </div>
        <i class="bi bi-kanban"></i>
      </div>

      <section class="favorite-section">
        <div class="favorite-title">
          <div>
            <span class="section-kicker">HIZLI ERİŞİM</span>
            <h3>Favori Uygulamalarım</h3>
          </div>
          <span>{{ this.projectStatus.applications.length }} uygulama</span>
        </div>

        <div class="favorite-scroll">
    @for (app of this.projectStatus.applications; track app.pid) {
    @if (app.isFavorite === true) {
    <button type="button"
          class="favorite-item"
          [class.active]="selectedApplication?.pid === app.pid"
          (click)="toggleFavorite(app.pid)">
    <img [src]="app.logo" [alt]="app.name">
    <span>
      <strong>{{ app.name }}</strong>
      <small>{{ app.type }}</small>
    </span>
  </button>
     }
    }
        </div>
      </section>

      <div class="application-workspace">
        <aside class="application-sidebar">
          <div class="sidebar-section">
            <button type="button"
                    class="sidebar-main-button"
                    [class.active]="applicationMode === 'projects'"
                    [disabled]="myProjects.length === 0"
                    (click)="setApplicationMode('projects')">
              <span><i class="bi bi-collection"></i> Projelerim</span>
              <small>{{ myProjects.length }}</small>
            </button>

            <button type="button"
                    class="sidebar-main-button"
                    [class.active]="applicationMode === 'new'"
                    (click)="setApplicationMode('new')">
              <span><i class="bi bi-plus-square"></i> Yeni Proje</span>
            </button>
          </div>

          <div class="category-section">
            <h3>Kategoriler</h3>
            @for (category of categories; track category.key) {
              <button type="button"
                      class="category-button"
                      [class.active]="selectedCategory === category.key"
                      (click)="selectCategory(category.key)">
                <span>{{ category.name }}</span>
                <small>{{ category.count }}</small>
              </button>
            }
          </div>
        </aside>

        <main class="application-browser">
          @if (applicationMode === 'new') {
            <div class="browser-heading">
              <div>
                <span class="section-kicker">UYGULAMALAR / SERVİSLER</span>
                <h2>Hizmet seçin</h2>
              </div>
              <span class="result-count">{{ filteredApplications.length }} sonuç</span>
            </div>

            <div class="application-toolbar">
              <label class="application-search">
                <i class="bi bi-search"></i>
                <input type="text" [value]="searchText" (input)="setSearchText($event)" placeholder="Uygulama ara...">
              </label>
              <select [value]="sortType" (change)="setSortType($event)">
                <option value="recommended">Önerilenler</option>
                <option value="name">Ada göre</option>
              </select>
            </div>

            <div class="application-grid">
              @for (app of filteredApplications; track app.pid) {
                <article class="application-card"
                         [class.selected]="selectedApplication?.pid === app.pid"
                         (click)="selectApplication(app)">
                  <div class="application-card-header">
                    <div class="application-identity">
                      <img [src]="app.logo" [alt]="app.name">
                      <div>
                        <strong>{{ app.name }}</strong>
                        <span>{{ app.type }}</span>
                      </div>
                    </div>

                    <button type="button"
                            class="favorite-button"
                            [class.active]="app.isFavorite"
                            (click)="toggleFavorite(app.pid)"
                            aria-label="Favori">
                      <i class="bi" [class.bi-star-fill]="app.isFavorite" [class.bi-star]="!app.isFavorite"></i>
                    </button>
                  </div>

                  <p>{{ app.description }}</p>

                  <div class="application-tags">
                    @for (tag of app.tags; track tag) {
                      <span>{{ tag }}</span>
                    }
                  </div>
                </article>
              } @empty {
                <div class="empty-list">
                  <i class="bi bi-search"></i>
                  <strong>Uygulama bulunamadı</strong>
                  <span>Arama veya kategori filtresini değiştirin.</span>
                </div>
              }
            </div>
          } @else {
            <div class="empty-list projects-empty">
              <i class="bi bi-collection"></i>
              <strong>Henüz oluşturulmuş projeniz yok</strong>
              <span>Yeni Proje bölümünden proje oluşturabilirsiniz.</span>
            </div>
          }
        </main>

        <aside class="application-detail">
          @if (selectedApplication) {
            <div class="detail-header">
              <img [src]="selectedApplication.logo" [alt]="selectedApplication.name">
              <div class="detail-header-content">
                <div class="detail-title">
                  <h2>{{ selectedApplication.name }}</h2>
                  <span>{{ selectedApplication.type }}</span>
                </div>
                <p>{{ selectedApplication.description }}</p>
              </div>
            </div>

            <div class="detail-information">
              <div class="detail-row"><span>Üretici</span><strong>{{ selectedApplication.vendor }}</strong></div>
              <div class="detail-row"><span>Ürün Tipi</span><strong>{{ selectedApplication.category }}</strong></div>
              <div class="detail-row"><span>Lisans Türü</span><strong>{{ selectedApplication.license }}</strong></div>
              <div class="detail-row"><span>Erişim</span><strong>{{ selectedApplication.access }}</strong></div>
              <div class="detail-row"><span>Sürüm</span><strong>{{ selectedApplication.version }}</strong></div>
            </div>

            <button type="button" class="documentation-button">
              Resmi Dokümantasyon <i class="bi bi-box-arrow-up-right"></i>
            </button>

            <div class="detail-statistics">
              <div class="statistic-box">
                <i class="bi bi-people"></i>
                <div><strong>{{ selectedApplication.activeUsers }}</strong><span>Aktif Kullanıcı</span></div>
              </div>
              <div class="statistic-box">
                <i class="bi bi-clock"></i>
                <div><strong>{{ selectedApplication.uptime }}</strong><span>Çalışma Süresi</span></div>
              </div>
            </div>
          } @else {
            <div class="empty-application-detail">
              <i class="bi bi-grid"></i>
              <strong>Bir uygulama seçin</strong>
              <p>Seçtiğiniz uygulamanın detayları burada görüntülenir.</p>
            </div>
          }
        </aside>
      </div>

      <footer class="step-footer">
        <button type="button" class="secondary-button" (click)="previousStep()">
          <i class="bi bi-arrow-left"></i> Geri
        </button>
        <button type="button" class="create-project-button" [disabled]="creatingProject || !canCreateProject" (click)="createProject()" [attr.aria-busy]="creatingProject">
          <i class="bi" [class.bi-rocket-takeoff]="!creatingProject" [class.bi-hourglass-split]="creatingProject"></i>
          @if (creatingProject) { Proje Oluşturuluyor... } @else { Projeyi Oluştur }
          <i class="bi bi-arrow-right"></i>
        </button>
      </footer>
    </fieldset>
  }

  <!-- STEP 4: Yalnızca başarılı kayıt sonrası -->
  @if (currentStep === 4 && createdProjectId !== null) {
    <div class="project-summary-step">
      <header class="summary-heading">
        <div><span class="section-kicker">PROJE ÖZETİ</span><h1>Projeniz hazır</h1><p>Seçimlerinizi inceleyin ve uygulamanızın kaynaklarına ulaşın.</p></div>
        <span class="summary-created"><i class="bi bi-check-circle-fill"></i> Oluşturuldu</span>
      </header>
      <div class="summary-grid">
        <section class="summary-card">
          <div class="summary-card-heading">
            <span class="summary-icon project" [style.color]="project.color || null"><i [class]="project.icon || 'bi bi-folder'"></i></span>
            <div><h2>Proje Bilgileri</h2><h3>{{ project.name }}</h3><p>{{ project.description || 'Proje açıklaması eklenmedi.' }}</p></div>
          </div>
          <div class="summary-data-row"><span>Proje türü</span><strong>Yeni Proje</strong></div>
          <div class="summary-data-row"><span>Paket</span><strong>{{ projectStatus.packetName }}</strong></div>
          <div class="summary-data-row"><span>Proje limiti</span><strong>{{ createdProjectCount }} / {{ projectStatus.maxProjectLimitsNumber }}</strong></div>
        </section>
        <section class="summary-card">
          <div class="summary-card-heading">
            <span class="summary-icon application">@if (selectedApplication?.logo) { <img [src]="selectedApplication!.logo" [alt]="selectedApplication!.name"> } @else { <i class="bi bi-box-fill"></i> }</span>
            <div><h2>Seçilen Uygulama</h2><div class="summary-app-name"><h3>{{ selectedApplication?.name }}</h3><span>{{ selectedApplication?.type }}</span></div><p>{{ selectedApplication?.description }}</p></div>
          </div>
          <div class="summary-data-row"><span>Geliştirici</span><strong>{{ selectedApplication?.vendor || '-' }}</strong></div>
          <div class="summary-data-row"><span>Sürüm</span><strong>{{ selectedApplication?.version || '-' }}</strong></div>
          <div class="summary-data-row"><span>Erişim</span><strong class="summary-access">{{ selectedApplication?.access || 'Kullanılabilir' }}</strong></div>
        </section>
      </div>
      <div class="summary-resources-heading"><h2>Uygulama Kaynakları</h2><p>Başlamak için web sitesini ve teknik dokümanları inceleyin.</p></div>
      <div class="summary-grid">
        <section class="summary-card summary-resource">
          <div class="summary-card-heading">
            <span class="summary-icon project"><i class="bi bi-globe2"></i></span>
            <div><h3>Web Sitesi</h3><p>Uygulama hakkında bilgi ve kullanım örnekleri.</p><span class="summary-site-label">{{ applicationWebsite || 'Uygulamanın resmi web sitesi henüz eklenmedi' }}</span></div>
          </div>
          <a class="summary-resource-button" [href]="applicationWebsite || null" [attr.aria-disabled]="!applicationWebsite" [attr.tabindex]="applicationWebsite ? 0 : -1" target="_blank" rel="noopener noreferrer">Web Sitesini Aç <i class="bi bi-box-arrow-up-right"></i></a>
        </section>
        <section class="summary-card summary-resource">
          <div class="summary-card-heading">
            <span class="summary-icon application"><i class="bi bi-book"></i></span>
            <div><h3>Teknik Dokümantasyon</h3><p>Kurulum, API referansı ve entegrasyon rehberleri.</p><div class="summary-doc-tags"><span>Hızlı Başlangıç</span><span>API Referansı</span><span>Entegrasyon</span></div></div>
          </div>
          <a class="summary-resource-button" [href]="applicationDocumentation || null" [attr.aria-disabled]="!applicationDocumentation" [attr.tabindex]="applicationDocumentation ? 0 : -1" target="_blank" rel="noopener noreferrer">Dokümanları İncele <i class="bi bi-box-arrow-up-right"></i></a>
        </section>
      </div>
      <footer class="summary-footer">
        <button type="button" class="secondary-button" (click)="goToDashboard()"><i class="bi bi-grid"></i> Dashboarda</button>
        <button type="button" class="primary-button" (click)="goToCreatedProject()"><i class="bi bi-arrow-right"></i> Projeye git</button>
        <button type="button" class="secondary-button" (click)="goToProjects()"><i class="bi bi-list-ul"></i> Projeleri listele</button>
      </footer>
    </div>
  }
    } @else {
      @if (!dashboardErrorMessage) { <div class="project-status-loading" role="status">Proje bilgileri yükleniyor...</div> }
    }
  </section>
</div>
<app-dashboard-error
  [errorMessage]="dashboardErrorMessage"
  homeUrl="/"
  (loginRequested)="GoToLogin()"
></app-dashboard-error>
